// Dynamic ROUTING
export const httpUserRouting= '/auth/user-permission-pages'

export const httpVerifyToken = '/api/admin/verify-token'

// AUTH
export const httpManageLogin = '/auth/login'
export const httpManageRegister = '/auth/signup'
export const httpValidateEmail = '/auth/validate-user-email'

export const httpResetPassReqCode = '/auth/request-password-reset'
export const httpResetPassVerifyCode = '/auth/verify-reset-code'
export const httpResetPass = '/auth/reset-password'


export const httpSendCode = '/auth/email-code'
export const httpVerifyCode = '/auth/verify-reset-code'
// ADMIN - USERS
export const httpGetUsers = '/api/admin/get-all-admin-users'
// export const getPermissionsbyID = '/api/admin/get-all-navigation-by-user-id-to-assign-permission'
export const getPermissionsbyID = '/api/admin/formatted-navbar'
export const httpPutPermissions = '/api/admin/update-user-navigation-by-user-id-to-assign-permission'
export const httpPutUsers = '/api/admin/update-admin'


export const httpGetUserAddress = '/users/addresses'
export const httpAddUserAddress = '/users/add-address'
export const httpEditUserAddress = '/users/edit-address'




// USER PORTAL

export const httpPostProfile = '/users/update-account'
